
import { defineComponent, PropType } from "vue";

export class ThumbnailItem {
  imgPath = "";
  clickAction = () => {};
  isDisabled = false;
  constructor(init?: Partial<ThumbnailItem>) {
    Object.assign(this, init);
  }

  static Empty() {
    return new ThumbnailItem({
      imgPath: "",
      isDisabled: false,
    });
  }
}

export default defineComponent({
  name: "Thumbnail",
  props: {
    item: { type: Object as PropType<ThumbnailItem> },
  },
});
